module.exports = __webpack_public_path__ + "site/img/ppzh.2f6a6a01.png";